module.exports = __webpack_public_path__ + "img/719-de6eb9.png";